import React from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { useLoading } from "../../hooks/useLoader";
import { useSecondLoading } from "../../hooks/useSecondLoader";

function Loader(props) {
  const { show } = useLoading();
  const { showSecond } = useSecondLoading();

  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={show || showSecond}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}

export default Loader;
